import { css } from '@emotion/core'
import theme from 'Theme'

const { mixins } = theme
const { fadeIn } = mixins

export default () => css`
  ${fadeIn()}
`
